import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useT } from "@/i18n";

export default function NotFound() {
  const t = useT();
  return (
    <div className="nx-container min-h-[60vh] flex items-center justify-center text-center py-24">
      <div>
        <div className="nx-mono text-xs uppercase tracking-[0.32em] text-[#38D8FF] mb-5">
          / {t.notFound.eyebrow}
        </div>
        <h1 className="nx-heading text-5xl md:text-6xl font-bold">{t.notFound.title}</h1>
        <p className="mt-4 text-white/65 max-w-md mx-auto">{t.notFound.body}</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-[#0057FF] hover:bg-[#2F80FF] text-white text-sm font-medium nx-cta-glow"
        >
          {t.notFound.backBtn} <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
